import { useMemo } from "react";
import { useScheduleContext } from "./context/useScheduleContext";

export const useEventUser = (resourceId: string | undefined) => {
    const { allResources } = useScheduleContext();
    return useMemo(() => {
        return allResources?.find((item: any) => item?.id === resourceId);
    }, [resourceId, allResources]);
};
